import { useBranding } from "@/context/BrandingContext";

// Logo de la gérance si importé, sinon logo officiel MADLO constat (horizontal ou empilé, positif ou négatif)
export default function BrandLogo({ className = "h-10", negative = false, chip = false, stacked = false }) {
  const { branding } = useBranding();
  if (branding.logo_url) {
    const img = <img src={branding.logo_url} alt={branding.agence?.nom || branding.nom_application} className={`${className} w-auto object-contain`} data-testid="brand-logo" />;
    return chip || (branding.logo_fond_blanc && negative) ? <div className="inline-flex bg-white rounded-md px-3 py-2">{img}</div> : img;
  }
  const src = `/madlo/${stacked ? "empile" : "horizontal"}${negative ? "-negatif" : ""}.webp`;
  return <img src={src} alt="MADLO constat" className={`${className} w-auto object-contain`} data-testid="brand-logo-madlo" />;
}
